<template>
    <div>
      <h2 class="text-1xl font-bold text-gray-700">
        Cofiguracion de tipo de usuarios
      </h2>
      <MainTypeOfUsers />
    </div>
  </template>
  
  <script>
  import MainTypeOfUsers from "@/components/Users/TypeOfUsers/MainTypeOfUsers.vue";
import { useRoute } from 'vue-router';
import { onBeforeMount, onMounted } from 'vue';
import { findSubmoduleIdByDescription } from '@/hisAcces';
  export default {
    name: "TypeOfUsers",
    components: {
        MainTypeOfUsers,
    },
  setup() {
    const route = useRoute();
    onBeforeMount(() => {
      if (!findSubmoduleIdByDescription(route.path)) {
        window.location.href = "/login";
      }
    });

    onMounted(() => {
      document.title =
        route.meta.title + process.env.VUE_APP_TITLE ||
        process.env.VUE_APP_TITLE;
    });
  },
  };
  </script>